export enum KimUrl {
  DEV = 'https://kit.predprof.edu-demo.ru',
  PROD = 'https://mydiag.mcko.ru',
}
